module.exports = __webpack_public_path__ + "img/technology_thumbnail-1-600x450.d39c3ddf.jpg";